document.addEventListener(
  'click',
  function (event) {
    var link = event.target.closest('.menu-list__list-item > a[aria-haspopup="true"]');
    if (!link) return;
    var li = link.closest('.menu-list__list-item');
    if (!li) return;
    /* Parent items with a dropdown never navigate on click, they only open the
       dropdown. A real hover can already flip aria-expanded to "true" before
       the click fires, so always re-dispatch to make sure it stays open. */
    event.preventDefault();
    li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
  },
  true
);
